// src/hooks/useExperiment.ts
import { useState, useEffect } from 'react';
import { getValue, fetchAndActivate } from 'firebase/remote-config';
import { logEvent } from 'firebase/analytics';

import { remoteConfig, analytics } from './config';

export function useExperiment(experimentId: string) {
  const [variant, setVariant] = useState<string>('A');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    console.log('Fetching remote config...');

    fetchAndActivate(remoteConfig)
      .then(() => {
        console.log('Remote config fetched successfully');
        const configValue = getValue(remoteConfig, experimentId);
        const variantValue = configValue.asString();
        console.log('Variant value:', variantValue);

        setVariant(variantValue);
        setLoading(false);

        // Log experiment exposure only if analytics is available
        if (analytics) {
          logEvent(analytics, 'experiment_exposure', {
            experiment_id: experimentId,
            variant: variantValue,
          });
        }
      })
      .catch((error) => {
        console.error('Error fetching remote config:', error);
        setError(error);
        setLoading(false);
      });
  }, [experimentId]);

  return { variant, loading, error };
}
